var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"sidebar"},[_c('img',{staticClass:"pt-4 pb-5",attrs:{"alt":"Subalogue logo","id":"logo","src":require("@/assets/logo.png"),"width":"40","height":"40"}}),_c('FMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }